/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import Select from 'react-select';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import BarChart from './ReturnRefundBarChart';
import { sortByOptionsForRefund } from '../helper';
import { setCurrencyFormat } from '../../../utils/helpers';

const ShowMonthDayCategoryWise = ({ dir, dataToShowForDatesSelected, categorisedBasedOn,
    title, viewReportButton, currentlyShow, currentlyTypeShow }) => {
    const categorisedBasedOnRef = useRef({ categorisedBasedOn });

    const [selectedOptions, setSelectedOptions] = useState([])
    const [sortBySelected, setSortBySelected] = useState(sortByOptionsForRefund[2])

    useEffect(() => {
        if (categorisedBasedOnRef?.current?.categorisedBasedOn !== categorisedBasedOn) {
            setSelectedOptions([])
        }
    }, [categorisedBasedOn])

    const changeFilter = (value) => {
        setSelectedOptions(value)
    };

    const currentDataByCategory = {};

    dataToShowForDatesSelected?.forEach((item) => {

        if (item && currentDataByCategory[item?.[categorisedBasedOn]]) {
            currentDataByCategory[item?.[categorisedBasedOn]]?.push(item);
        } else if (item && (!item?.[categorisedBasedOn] || item?.[categorisedBasedOn] === 'null')) {
            if (currentDataByCategory['N/A']) {
                currentDataByCategory['N/A']?.push(item)
            } else {
                currentDataByCategory['N/A'] = [item]
            }
        } else {
            currentDataByCategory[item?.[categorisedBasedOn]] = [item]
        }
    });

    const currentMonthCat = Object.keys(currentDataByCategory);

    let dataToPlot = [];
    const options = []

    const reduceCallback = (acc, day) => {
        let date;
        let dateWithMonthYear;
        if (currentlyTypeShow?.value === 'daily') {
            date = moment(`${day.salesMonth}-${day?.day}-${day?.salesYear}`, 'MMM-D-YYYY');
            dateWithMonthYear = date.format('D-MMM-YYYY-DDD');
        }
        else {
            date = moment(`${day.salesMonth}-${day?.salesYear}`, 'MMM-YYYY');
            dateWithMonthYear = date.format('MMM-YYYY');
        }
        // date = moment(`${day.salesMonth}-${day?.day}-${day?.salesYear}`, 'MMM-D-YYYY');
        // const month = moment(`${day.salesMonth}-${day?.day}-${day?.salesYear}`, 'MMM-D-YYYY');
        // const dateWithMonthYear = date.format('D-MMM-YYYY-DDD');

        if (acc[dateWithMonthYear]) {
            acc?.[dateWithMonthYear]?.push(day)
        } else {
            acc[dateWithMonthYear] = [day]
        }
        return acc
    }

    for (let i = 0; i < currentMonthCat.length; i += 1) {
        const cat = currentMonthCat[i];
        const currentMonth = currentDataByCategory?.[cat] ?? [];

        const currentYearMonthDayWise = currentMonth?.reduce(reduceCallback, {});
        let currentYearMonthMax = 0;
        let currentYearMonthRefundMax = 0;

        currentMonth?.forEach((item) => {
            currentYearMonthMax += Number(item.orderCount)
            currentYearMonthRefundMax += Number(item.refundOrderCount)
            // if (currentYearMonthMax < Number(item.amount))
            //     currentYearMonthMax = Number(item.amount)
        }
        );
        options.push({
            value: cat, label: cat
        })
        dataToPlot.push({
            title: cat,
            currentYearMonthDayWise,
            currentYearMonthMax,
            currentYearMonthRefundMax
        })
    }

    if (selectedOptions?.length) {
        const selected = selectedOptions?.reduce((acc, item) => {
            acc[item?.value] = item.value
            return acc
        }, {})
        dataToPlot = dataToPlot.filter(item => selected[item.title])
    }

    const sortBy = sortBySelected?.value;

    if (sortBy === 'title') {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
    } else {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy] < b?.[sortBy] ? 1 : -1)
    }

    return (
        <>
            <div className="card__title row align-items-center">
                <h5 className="bold-text col-md-3">{title}</h5>
                <div className="form__form-group mb-0 col-md-7" id='dvChartFilter'>
                    <div className="row justify-content-center align-items-center">
                        <div className="col-6">
                            <span className="form__form-group-label font-weight-bold">
                                {`Select ${currentlyShow?.value}`}</span>
                            <div className="form__form-group-field">
                                <Select
                                    value={selectedOptions}
                                    options={options.sort((a, b) => a.label > b.label ? 1 : -1)}
                                    clearable={false}
                                    placeholder={`Select ${currentlyShow?.value}`}
                                    className="select_filter"
                                    onChange={changeFilter}
                                    classNamePrefix="react-select"
                                    isMulti

                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <span className="form__form-group-label font-weight-bold">Sort By</span>
                            <div className="form__form-group-field">
                                <Select
                                    value={sortBySelected}
                                    options={sortByOptionsForRefund}
                                    clearable={false}
                                    placeholder="Sort By"
                                    className="select_filter"
                                    onChange={setSortBySelected}
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-2" id='dvChartView'>
                {viewReportButton?.()}</div>
            </div>
            {dataToPlot?.length ? dataToPlot?.map((category, index) => (
                <Row key={category.title}>
                    <Col sm={4} md={2}><CardText>{category.title} <br />
                        {`Order : ${setCurrencyFormat(Number(category.currentYearMonthMax).toFixed(2), false)}`}
                        <br />
                        {`Refund : ${setCurrencyFormat(Number(category.currentYearMonthRefundMax).toFixed(2), false)}`}
                        </CardText></Col>
                    <Col sm={8} md={10}>
                        <BarChart dir={dir}
                            totalDays={365}
                            currentYearMonthDayWise={category.currentYearMonthDayWise}
                            height={275}
                            showTitle={false}
                            category={category.title}
                            categorisedBasedOn={categorisedBasedOn}
                            index={index}
                            currentlyShowType={currentlyTypeShow}
                        /></Col>
                </Row>
            )) : 'No data to display'}
        </>

    )
}

ShowMonthDayCategoryWise.propTypes = {
    dir: PropTypes.string.isRequired,
    dataToShowForDatesSelected: PropTypes.array.isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
    categorisedBasedOn: PropTypes.string,
    currentlyShow: PropTypes.object.isRequired,
    currentlyTypeShow: PropTypes.object.isRequired

};

ShowMonthDayCategoryWise.defaultProps = {
    title: 'Day Comparison By Category',
    categorisedBasedOn: 'productCategory'
}

export default ShowMonthDayCategoryWise;
